import React, { CSSProperties } from "react";
import { FontIconProps } from "./fontIcon.model";
import "@companion-core/web/src/Assets/Styles/scss/fontIcon.scss";

export const FontIcon = ({ name, size, className, style = {}, ...props }: FontIconProps) => {
  const webStyle: CSSProperties = {
    ...(style as CSSProperties),
    ...(size ? { fontSize: size } : {}),
  };
  return (
    <span
      className={`font-icon icon-${name} ${className ? className : ""}`}
      style={webStyle}
      {...props}
    />
  );
};
